//#region IMPORT
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import M_TBM_CUSTOM from './M_TBM_CUSTOM';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { NavBarInfoActions } from '../../../../Reducer/NavBarInfoReducer';
import { useSearch1, useSearch2 } from './M_TBM_CUSTOM_Query';
import Commons from '../../../../Services/Common/Common';
import { useBackStack } from '../../../../Hooks/back/useBackStack'; // 규칙 3 추가
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
//#endregion

function M_TBM_CUSTOMF() {
  //#region 변수
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const { navigate } = useAppNavigate();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [userCount, setUserCount] = useState(0);
  const [check, setCheck] = useState([]);
  const [ready, setReady] = useState(false);
  const ws = useRef(null);
  const tbmCdRef = useRef(null);
  const [modalToggle1, setModalToggle1] = useState(false);
  const [modalToggle2, setModalToggle2] = useState(false);
  const [modalToggle3, setModalToggle3] = useState(false);
  const [modalToggle4, setModalToggle4] = useState(false);

  const modalToggleRef = useRef(modalToggle1);
  const modalToggle2Ref = useRef(modalToggle2);
  const activeStepRef = useRef(activeStep);
  //#endregion

  //#region
  useBackStack({
    type: 'custom',
    enabled: activeStep === 2,
    onBack: () => {
      if (modalToggle2Ref.current) {
        setModalToggle2(false);
        return;
      }
      dispatch(
        showSnackbar({
          message: 'TBM 진행 중 뒤로가기가 불가능 합니다.',
          type: 'warning',
        })
      );
    },
  });

  useBackStack({
    type: 'step',
    enabled: activeStep > 0 && activeStep !== 2,
    onBack: () => {
      dispatch(CommonActions.setActiveStep(activeStepRef.current - 1));
    },
  });
  //#endregion

  //#region 이벤트 동기화
  useEffect(() => {
    modalToggleRef.current = modalToggle1;
    modalToggle2Ref.current = modalToggle2;
    activeStepRef.current = activeStep;
  }, [modalToggle1, modalToggle2, activeStep]);

  useEffect(() => {
    Init();
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('TBM'));
    dispatch(NavBarInfoActions.setBgColor('#F3F7F8'));

    let listener;
    if (Capacitor.isNativePlatform()) {
      listener = App.addListener('appStateChange', async (state) => {
        if (state.isActive) {
          if (!ws.current || ws.current.readyState !== WebSocket.OPEN) {
            try {
              if (ws.current) ws.current.close();
              await OpenWebSocket();
            } catch (error) {
              setSnackbar((prev) => ({
                ...prev,
                open: true,
                message:
                  '연결을 복구할 수 없습니다. 페이지를 새로고침해주세요.',
                type: 'error',
              }));
            }
          } else {
            Search2Async({ tbmCd: tbmCdRef.current });
          }
        }
      });
    }

    return () => {
      if (ws.current) ws.current.close();
      if (listener) listener.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Init = async () => {
    try {
      await Search1Async();
    } catch (e) {
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    }
  };
  //#endregion

  //#region 쿼리
  const { runAsync: Search1Async } = useSearch1({
    onSuccess: (rows) => {
      tbmCdRef.current = rows[0].tbmCd;
      OpenWebSocket();
    },
  });

  const { runAsync: Search2Async } = useSearch2({
    onSuccess: (rows) => {
      if (rows?.length > 0) {
        tbmCdRef.current = rows[0].tbmCd;
        const step = rows[0].eStep;
        dispatch(CommonActions.setActiveStep(step));
      } else {
        if (ws.current) ws.current.close();
        dispatch(CommonActions.setActiveStep(0));
        navigate('/Home');
      }
    },
  });
  //#endregion

  //#region 웹소켓 핸들러
  const OpenWebSocket = useCallback(async () => {
    ws.current = new WebSocket(
      `${process.env.REACT_APP_WEB_SOCKET}?roomId=${
        tbmCdRef.current
      }&userId=${Commons.DecryptoAES(userInfo.userid)}`
    );

    ws.current.onopen = () => {
      console.log('웹소켓 연결됨');
      Search2Async({ tbmCd: tbmCdRef.current });
    };

    ws.current.onmessage = (event) => {
      const HandleText = (text) => {
        try {
          const data = JSON.parse(text);
          if (data.type === 'userCount') {
            setUserCount(data.count);
          } else if (data.type === 'roomState') {
            setCheck(data.check);
          } else if (data.type === 'message') {
            setMessages((prev) => [...prev, data.content]);
          } else if (data.type === 'prev') {
            if (data.content) {
              setModalToggle2(false);
              setModalToggle4(false);
              dispatch(CommonActions.setActiveStep(data.step));
            }
          } else if (data.type === 'next') {
            if (data.content) {
              const adminStep = data.step;
              if (modalToggleRef.current === true) {
                setModalToggle1(false);
                dispatch(CommonActions.setActiveStep(adminStep));
              } else {
                setModalToggle2(true);
                setTimeout(() => {
                  setModalToggle2(false);
                  dispatch(CommonActions.setActiveStep(adminStep));
                }, 3000);
              }
            }
          } else if (data.type.includes('check')) {
            setCheck((prev) => {
              if (
                !prev.some(
                  (item) => item.id === data.id && item.type === data.type
                )
              ) {
                return [...prev, data];
              }
              return prev;
            });
          } else if (data.type === 'end') {
            if (data.waiting === 'Y') {
              setModalToggle4(true);
            } else if (data.waiting === 'N') {
              setModalToggle4(false);
            } else {
              if (ws.current) ws.current.close();
              setModalToggle3(true);
              setTimeout(() => {
                setModalToggle3(false);
                dispatch(CommonActions.setActiveStep(0));
                navigate('/Home');
              }, 3000);
            }
          }
        } catch (e) {
          setMessages((prev) => [...prev, text]);
        }
      };

      if (event.data instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => HandleText(reader.result);
        reader.readAsText(event.data);
      } else {
        HandleText(event.data);
      }
    };

    ws.current.onerror = (error) => console.error('WebSocket 오류:', error);
    ws.current.onclose = () => console.log('웹소켓 연결 종료됨');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo, dispatch, navigate, Search2Async]);

  const SendMessage = () => {
    if (ws.current && input.trim() !== '') {
      ws.current.send(input);
      setInput('');
    }
  };

  const ActiveButton = (data) => {
    if (ws.current && ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(JSON.stringify(data));
    }
  };

  const TbmEnd = () => {
    dispatch(CommonActions.setActiveStep(0));
    if (ws.current) ws.current.close();
  };
  //#endregion

  return (
    <div className="wrap">
      <M_TBM_CUSTOM
        userInfo={userInfo}
        lanList={lanInfo}
        activeStep={activeStep}
        userCount={userCount}
        setUserCount={setUserCount}
        check={check}
        setCheck={setCheck}
        ready={ready}
        setReady={setReady}
        tbmCdRef={tbmCdRef}
        setModalToggle1={setModalToggle1}
        modalToggle1={modalToggle1}
        setModalToggle2={setModalToggle2}
        modalToggle2={modalToggle2}
        setModalToggle3={setModalToggle3}
        modalToggle3={modalToggle3}
        setModalToggle4={setModalToggle4}
        modalToggle4={modalToggle4}
        ActiveButton={ActiveButton}
        SendMessage={SendMessage}
        TbmEnd={TbmEnd}
      />
    </div>
  );
}

export default M_TBM_CUSTOMF;
